module.exports = __webpack_public_path__ + "static/media/1.a3bc6794.jpg";